import axios from "axios";
import UrlInfo from "./urlInfo";

export default {
  /**
   * @param {HTMLCollectionOf<Element>} elements
   * @param {string} navigatedText
   * @param {string} eventsId
   * @returns
   */
  addReplacePageClickEventToElements: function (
    elements,
    navigatedText,
    eventsId
  ) {
    if (!navigatedText || !eventsId) {
      return;
    }

    removeEventHandlers(eventsId);
    for (let element of elements) {
      let urlInfo = new UrlInfo(element.getAttribute("href"));
      if (!urlInfo.isValidUrl || !urlInfo.goesToSameSite()) {
        continue;
      }

      var eventFunction = async function (event) {
        event.preventDefault();
        if (
          !(await getAndReplacePage(
            urlInfo.fullUrl,
            navigatedText,
            !urlInfo.goesToCurrentUrl()
          ))
        ) {
          urlInfo.goToPage();
        }
      };

      addEventHandler(eventsId, element, "click", eventFunction);
      element.addEventListener("click", eventFunction);
    }
  },

  /**
   * @param {AxiosResponse<any, any>} response
   * @param {boolean} push
   * @param {string} url
   * @param {string} navigatedText
   */
  loadPartialView: function (response, push, url, navigatedText) {
    let template = document.createElement("html");
    template.innerHTML = response.data;
    let title = template.getElementsByTagName("title")[0].innerText;

    replaceElementWithId("mainBody", template);
    replaceElementWithId("toppbild", template);
    replaceElementWithId("puffyta", template);
    replaceElementWithId("spraklank", template);
    replaceElementWithId("spraklank-mobil", template);
    replaceElementWithId("breadcrumb", template);

    updateObserveAttibute();
    resetFocus(navigatedText, title);
    updateUrl(push, title, url);
  },

  /**
   * @param {AxiosResponse<any, any>} response
   * @param {boolean} push
   * @param {string} url
   * @param {string} navigatedText
   */
  loadPartialViewMobile: function (response, push, url, navigatedText) {
    var contentType = response.headers["content-type"];
    if (!contentType || !contentType.includes("text/html") || contentType.includes("application/json")) { 
      return false;
    }

    let template = document.createElement("html");
    template.innerHTML = response.data;
    let title = template.getElementsByTagName("title")[0].innerText;
    let newMain = template.querySelector("main");

    let menuIsShowing =
      document.querySelector(".mainmenu-mobile-btn.show") != null;
    const main = document.querySelector("main");
    main.replaceWith(newMain);
    replaceElementWithId("spraklank", template);
    replaceElementWithId("spraklank-mobil", template);

    updateObserveAttibute();
    resetFocus(navigatedText, title);
    updateUrl(push, title, url);

    if (menuIsShowing) {
      document.getElementById("mainmenu-mobile-btn").click();
    }
    
    return true;
  },

  getAndReplacePage: getAndReplacePage,
  updateObserveAttibute: updateObserveAttibute,
};

/**
 * @type {{[eventsId:string]:{element: Element, eventType: string, eventFunction: (event: any) => Promise<void>}[]}}
 */
var eventHandlers = {};

/**
 * @param {string} eventsId
 * @param {Element} element
 * @param {string} eventType
 * @param {(event: any) => Promise<void>} eventFunction
 */
function addEventHandler(eventsId, element, eventType, eventFunction) {
  if (!eventHandlers[eventsId]) {
    eventHandlers[eventsId] = [];
  }
  eventHandlers[eventsId].push({
    element: element,
    eventType: eventType,
    eventFunction: eventFunction,
  });
}

/**
 * @param {string} eventsId
 */
function removeEventHandlers(eventsId) {
  if (eventHandlers[eventsId]) {
    while (eventHandlers[eventsId].length > 0) {
      var handler = eventHandlers[eventsId].pop();
      handler.element.removeEventListener(
        handler.eventType,
        handler.eventFunction
      );
    }
    delete eventHandlers[eventsId];
  }
}

/**
 * @param {string} url
 * @param {string} navigatedText
 * @param {boolean} addPageToHistory
 * @returns {boolean}
 */
async function getAndReplacePage(url, navigatedText, addPageToHistory) {
  let replacePageData = await getReplacePageData(url);
  if (replacePageData != null) {
    replacePageData.currentMain.replaceWith(replacePageData.newMain);
    replacePageData.currentHeader.replaceWith(replacePageData.newHeader);

    updateObserveAttibute();
    resetFocus(navigatedText, replacePageData.title);
    updateUrl(addPageToHistory, replacePageData.title, url);
    return true;
  }
  return false;
}

/**
 * @param {string} url
 */
async function getReplacePageData(url) {
  try {
    var value = await axios.get(url);

    var contentType = value.headers["content-type"];
    if (!contentType || !contentType.includes("text/html") || contentType.includes("application/json")) { 
      return null;
    }

    let template = document.createElement("html");
    template.innerHTML = value.data;

    if (template != null && sameStylesheetsAsCurrentPage(template)) {
      let currentMain = document.getElementsByTagName("main")[0];
      let currentHeader = document.getElementsByTagName("header")[0];
      let newMain = template.getElementsByTagName("main")[0];
      let newHeader = template.getElementsByTagName("header")[0];
      let title = template.getElementsByTagName("title")[0].innerText;

      if (currentMain && currentHeader && newMain && newHeader) {
        blacklistElements();
        return {
          currentMain: currentMain,
          currentHeader: currentHeader,
          newMain: newMain,
          newHeader: newHeader,
          title: title,
        };
      }

      function blacklistElements() {
        addBlacklistedElement("#mobile-menu-container");
      }

      /**
       * @param {string} selector
       */
      function addBlacklistedElement(selector) {
        let newElement = template.querySelector(selector);
        let currentElement = document.querySelector(selector);
        if (newElement && currentElement) {
          newElement.replaceWith(currentElement);
        }
      }
    }
  } catch (err) {
    console.log(err);
  }
  return null;
}

/**
 * @param {string} id
 * @param {HTMLHtmlElement} template
 */
function replaceElementWithId(id, template) {
  let element = document.getElementById(id);
  if (element) {
    let newElement = template.querySelector("#" + id);
    element.replaceWith(newElement);
  }
}

function updateObserveAttibute() {
  let body = document.querySelector("body");
  let dataUpdate = body.getAttribute("data-observe-update");
  let nr = parseInt(dataUpdate);
  body.setAttribute("data-observe-update", nr + 1);
}

/**
 * @param {string} navigatedText
 * @param {string} title
 */
function resetFocus(navigatedText, title) {
  document.getElementById("resetfocus").innerText = navigatedText + " " + title;
  document.getElementById("resetfocus").focus();
  document.getElementById("resetfocus").blur();
}

/**
 * @param {boolean} push
 * @param {string} title
 * @param {string} url
 */
function updateUrl(push, title, url) {
  if (push) {
    history.pushState(null, title, url);
    document.title = title;
  }
}

/**
 * @param {HTMLHtmlElement} template
 * @returns {boolean}
 */
function sameStylesheetsAsCurrentPage(template) {
  let stylesheetsCurrentPage = getStylesheetsUrl(
    document.getElementsByTagName("head")[0]
  );
  let stylesheetsNextPage = getStylesheetsUrl(
    template.getElementsByTagName("head")[0]
  );

  return (
    stylesheetsCurrentPage.sort().join() === stylesheetsNextPage.sort().join()
  );

  /**
   * @param {HTMLHeadElement} head
   * @returns {string[]}
   */
  function getStylesheetsUrl(head) {
    let stylesheetsUrl = [];
    head?.querySelectorAll('link[rel="stylesheet"]')?.forEach((link) => {
      if (link.hasAttribute("href")) {
        stylesheetsUrl.push(link.getAttribute("href"));
      }
    });
    return stylesheetsUrl;
  }
}
